import http from '../../utils/httpService';
import { ROLES_ROUTE } from './constants';

/**
 *
 * @returns {*}
 */
const requestRoles = () => (
    http.request( ROLES_ROUTE, 'GET', null, false )
);

export {
    requestRoles
};

